import Axios from "../BaseAxios";
import { API_COMMON_URL } from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";
import authToken from "../../common/authToken";
import AmplitudeHelper from "../../amplitude";
import router from "../../router";
import { ROUTER_URL } from "../../constants/urls";

const PaymentApiHelper = {
  getPaymentOrderId: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_COMMON_URL.getOrderId,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
  initiatePayment(
    transaction_id,
    amount,
    displaName,
    description,
    order_id,
    fnSuccessResponse = null,
    fnFailureResponse = null,
    currency_code = null,
    name = null,
    email = null,
    contact = null
  ) {
    try {
      let user = authToken.decodedToken();
      var options = {
        key: process.env.VUE_APP_RAZORPAY_KEY, // Enter the Key ID generated from the Dashboard
        amount: amount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: currency_code ? currency_code : "INR",
        name: displaName,
        description: description,
        image: this.logo,
        order_id: order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: function(response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
          console.log(response);
          if (fnSuccessResponse != null) {
            store.state.payment.razorpayPaymentId =
              response.razorpay_payment_id;
            store.state.payment.razorpayOrderId = response.razorpay_order_id;
            fnSuccessResponse(response);
          }
        },
        prefill: {
          name: name ? name : user.name,
          email: email ? email : user.email,
          contact: contact ? contact : "91" + user.mobile,
        },
        notes: {
          transaction_id: transaction_id,
        },
        theme: {
          color: "#5271FF",
        },
        modal: {
          ondismiss: function() {
            PaymentApiHelper.paymentFailed(
              "None",
              order_id,
              "Failed",
              transaction_id
            );
          },
        },
      };
      var rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function(response) {
        PaymentApiHelper.paymentFailed(
          response.error.metadata.payment_id,
          response.error.metadata.order_id,
          response.error.source,
          transaction_id
        );
        if (fnFailureResponse != null) {
          fnFailureResponse(response);
        }
      });

      rzp1.open();
    } catch (err) {
      console.log(err);
    }
  },

  verifyPayment(
    razorpay_payment_id,
    razorpay_order_id,
    razorpay_signature,
    transaction_id,
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    var requestParams = {};
    requestParams[Keys.RAZORPAY_PAYMENT_ID] = razorpay_payment_id;
    requestParams[Keys.ORDER_ID] = razorpay_order_id;
    requestParams[Keys.RAZORPAY_PAYMENT_SIGNATURE] = razorpay_signature;
    requestParams[Keys.TRANSACTION_ID] = transaction_id;

    Axios.request_POST(
      API_COMMON_URL.verifyOrderStatus,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      false
    );
  },

  //TODO : Update Failed Transactions API
  paymentFailed(
    razorpay_payment_id,
    razorpay_order_id,
    source,
    transaction_id
  ) {
    var requestParams = {};
    requestParams[Keys.RAZORPAY_PAYMENT_ID] = razorpay_payment_id;
    requestParams[Keys.ORDER_ID] = razorpay_order_id;
    requestParams[Keys.SOURCE] = source;
    requestParams[Keys.TRANSACTION_ID] = transaction_id;
    requestParams[Keys.IS_FAILED] = true;

    Axios.request_POST(
      API_COMMON_URL.verifyOrderStatus,
      requestParams,
      {},
      null,
      null,
      false
    );
  },
  assignSessionToStudentAfterpaymentSuccess(
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    var requestParams = {};
    requestParams[Keys.PAYMENT_ID] = store.state.payment.razorpayPaymentId;
    requestParams[Keys.STUDENT_ID] = store.state.payment.studentId;

    Axios.request_POST(
      API_COMMON_URL.groupSessionStudentLink,
      requestParams,
      {},
      fnSuccessResponse,
      fnFailureResponse,
      false
    );
  },
  getMembershipPaymentOrderId: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_COMMON_URL.membershipRazorpayMakeOrder,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },

  // verifyPayPalPayment: (
  //   requestParams,
  //   successHandler = null,
  //   failureHandler = null
  // ) => {
  //   Axios.request_POST(
  //     API_COMMON_URL.membershipPayPalCheckout,
  //     requestParams,
  //     {},
  //     successHandler,
  //     failureHandler,
  //     false
  //   );
  // },

  createOrder: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_COMMON_URL.createOrder,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },

  verifyPayPalPayment: (order_id, paymentId, workshopId) => {
    store.state.workshop.buttonLoading = true;

    const paymentVerifySuccessHandler = (res) => {
      console.log(res);
      if (workshopId) {
        AmplitudeHelper.registerAmplitudeEvent(
          "workshop membership registration success",
          {
            "workshop name": store.state.sessionSeriesDetails.data.title,
          }
        );
      }

      var param = {};
      var userProperty = {};

      if (store.state.sessionSeriesDetails.data) {
        param = {
          "workshop name": store.state.sessionSeriesDetails.data.title,
        };
      }

      if (store.state.isMembershipEnabled) {
        if (authToken.decodedToken().membership_validity ? false : true) {
          param["membership type"] = "new";
        } else {
          param["membership type"] = "renewal";
        }

        userProperty["membership type"] = "Eblity Member";
      } else {
        userProperty["membership type"] = "Premium Member";
      }

      AmplitudeHelper.setUserProperty(userProperty);

      AmplitudeHelper.registerAmplitudeEvent("new membership success", param);

      store.state.membership.userMembership = res.data.data;
      localStorage.setItem("token", res.data.token);

      authToken.deleteCookie(`accesstoken`);

      document.cookie = `accesstoken=${res.data.token}; domain=.eblity.com`;

      if (res.data.data.is_preferences_set) {
        router.push({
          name: ROUTER_URL.publicMembership.children.membershipThankYou.name,
        });
      } else {
        router.push({
          name: ROUTER_URL.publicUser.children.preferences.name,
        });
      }
    };

    const paymentVerifyFailureHandler = (res) => {
      console.log(res);
      store.state.workshop.buttonLoading = false;
    };

    var requestParams = {};
    requestParams[Keys.PAYPAL_PAYMENT_ID] = paymentId;
    requestParams[Keys.ORDER_ID] = order_id;

    Axios.request_POST(
      API_COMMON_URL.verifyOrderStatus,
      requestParams,
      {},
      paymentVerifySuccessHandler,
      paymentVerifyFailureHandler,
      false
    );
  },
};

export default PaymentApiHelper;
